import React from 'react';
import DOMPurify from 'dompurify';
import type { AIChatMessage as AIChatMessageData } from './types';
import {
	MessageWrapper,
	MessageAvatarSlot,
	MessageBubbleContent,
	MessageBubble,
	MessageExtraContentWrapper,
} from './AIChat.Styled';

export type AIChatMessageProps = {
	message: AIChatMessageData;
	continued: boolean;
	assistantAvatarSrc?: string;
	assistantAvatarAlt?: string;
};

export function AIChatMessage({
	message,
	continued,
	assistantAvatarSrc,
	assistantAvatarAlt = 'Assistant',
}: AIChatMessageProps): React.ReactElement {
	const isUser = message.role === 'user';
	const showAvatar = !isUser && !continued && Boolean(assistantAvatarSrc);
	const reserveAvatarSpace = !isUser && Boolean(assistantAvatarSrc);

	return (
		<MessageWrapper $isUser={isUser} $continued={continued}>
			{reserveAvatarSpace && (
				<MessageAvatarSlot
					$visible={showAvatar}
					style={{ backgroundImage: `url(${assistantAvatarSrc})` }}
					role={showAvatar ? 'img' : undefined}
					aria-label={showAvatar ? assistantAvatarAlt : undefined}
				/>
			)}
			<MessageBubbleContent>
				<MessageBubble $isUser={isUser} $isError={Boolean(message.isError)}>
					<div dangerouslySetInnerHTML=
						{{ __html: typeof window !== 'undefined' 
							? DOMPurify.sanitize(message.content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')) 
							: message.content
								.replace(/&/g, '&amp;')
								.replace(/</g, '&lt;')
								.replace(/>/g, '&gt;')
								.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
				</MessageBubble>
				{message.extraContent && (
					<MessageExtraContentWrapper>{message.extraContent}</MessageExtraContentWrapper>
				)}
			</MessageBubbleContent>
		</MessageWrapper>
	);
}
